import { render, staticRenderFns } from "./Cockpit.vue?vue&type=template&id=5b6aa142"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/cockpit.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Cockpit.vue?vue&type=style&index=1&id=5b6aa142&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports